import { render, staticRenderFns } from "./DocumentSharing.vue?vue&type=template&id=7054b039&scoped=true&"
import script from "./DocumentSharing.vue?vue&type=script&lang=ts&"
export * from "./DocumentSharing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7054b039",
  null
  
)

export default component.exports